import { BasicSelect, MultiSelect } from 'vue-search-select'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import CryptoJS from 'crypto-js'
import Pagination from './../../../shared/components/pagination'
import CustomExpandableTable from '../../../shared/components/customExpandableTable'
import Loader from '../../../shared/components/loader'
import CONSTANT from '../../../shared/constants/constant'
import Util from '../../../shared/util/util'
import Treeselect from '@riophae/vue-treeselect'
import TripServices from '../../services/firstAndLastmilemanagement.service'
import ClientService from '../../../clientmanagement/services/clientmanagement.service';
import CreateBulkdeliveryconfig from './CreateBulkdeliveryconfig'

import XLSX from 'xlsx'
const moment = require('moment')

export default {
  name: 'bulkdeliveryconfig',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    CreateBulkdeliveryconfig,
    Multiselect,
  },
  data: function () {
    return {
      createFTCCashDeposit: false,
      isLoading: false,
      companyNamelist: [],
      tableColumn: [
        "Consignee Name",
        "Branch",
        "Min. MPS",
        "Created By",
        "Created Date",
        "Last Modified By",
        "Last Modified Date",
        "Status",
        "Action",
      ],
      tableItems: [],
      tableData:[],
      selectedHub: null,
      hublist: [],
      totalPage: 0,
      currentPage: 1,
      total: 0,
      totalCount: 0,
      perPage: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      offset: 0,
      AWB: "",
      Action: "",
      showCreateLMConfig:false,
      useremail: "",
      Clientlist:[],
      parentData:{},
      selectedClient: null,
    };
  },
  computed: {},
  async mounted () {
    var userdetailEncrypt = window.localStorage.getItem(
      'cargoAutoaccessuserdata'
    )
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
    var plaintext = bytes.toString(CryptoJS.enc.Utf8)
    var userdetail = JSON.parse(plaintext)
    this.hubid = userdetail.hubID[0];
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email
    this.isLoading = true;
    await Promise.all([
      this.getConfig(),
      this.getHubAccessList(),
      // this.getCompanyShortName()
    ]) 
    this.isLoading = false;
  },
  methods: {
    search(){
      this.currentPage = 1;
      this.offset = 0;
      this.getConfig();
    },
    async getConfig () {
      try {
        this.isLoading = true
        this.tableItems = [];
        let input = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if (this.selectedClient && this.selectedClient.value) {
          input.consigneename = this.selectedClient.value
        }
        if (this.selectedHub && this.selectedHub.value) {
          input.hubid = this.selectedHub.value;
        } else if (this.hubid) {
          input.hubid = this.hubid;
        }
        let result = await TripServices.getBulkDeliveryConfig(input);
        if (result.data.code == 200) {
          this.totalCount = result.data.data.count
          this.tableData = result.data.data.rows;
          let tempData = result.data.data.rows.map(el => {
            let responseObj = {
              'id': el.id,
              'Consignee Name': el.consigneename,
              'Branch': el.hubname,
              'Min. MPS': el.minmps,
              'Created By': el.createdby,
              'Created Date': Util.displayDateTimeFormat(el.createddate),
              'Last Modified By': el.lastmodifiedby,
              'Last Modified Date': Util.displayDateTimeFormat(el.lastmodifieddate),
              "Status": el.status,
            }
            return responseObj;
          })
          this.tableItems = tempData;
          this.getConsigneeName();
        } else {
          this.totalCount = 0;
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false
      } catch (err) {
        console.log(err)
        this.isLoading = false
      }
    },
    selectHub(data){
      this.selectedHub = data;
      this.originSearch = data.value;
    },
    selectClient(data){
      this.selectedClient = data;
    },
    async getHubAccessList () {
      try {
        let InputPayload = {
          userid: this.localuserid
        }
        // this.isLoading = true;
        let response = await TripServices.getHubAccessList(InputPayload)
        let list = response.data.data.hubaccess
        list.forEach(el => {
          this.hublist.push({
            'value': el.HubID,
            'text': el.HubName
          })
        })
      } catch (err) {
        console.log(err)
      }
    },
    onPageChange(page){
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getConfig();
    },
    showLMConfiguration(type,data) {
      this.showCreateLMConfig = true;
      this.parentData = {
        hublist: this.hublist,
        clientlist : this.Clientlist,
        action: type,
        useremail: this.useremail
      }
      if (type== 'update') {
        let obj = this.tableData.find(o => o.id === data.id);
        this.parentData.data = obj
      }
    },
    getCustomTableEvent(event) {
      console.log(event);
      if (event.actionType == 'edit') {
        this.showLMConfiguration('update', event)
      } else {
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
          this.updatestatus(event);
        }).catch((err)=>{
          console.log(err)
        });
      }
    },
    async updatestatus(input) {
      let payload = {
        configid : input.id,
        lastmodifiedby: this.useremail
      }
      let obj = this.tableData.find(o => o.id === input.id);
      payload.hubid = obj.hubid;
      payload.consigneename = obj.consigneename;
      if (input.actionType == 'active') {
        payload.status = 0
      } else if (input.actionType == 'inactive') {
        payload.status = 1
      }
      let result = await TripServices.updateBulkDeliveryStatus(payload);
      if(result.data.code == 200) {
        this.getConfig()
        let message = input.actionType == 'inactive' ? "Configuration Activated": "Configuration Inactivated";
        this.$alert(message, "", "success");
      } else{
        this.$alert(result.data.message, "", "error");
      }
    },
    async getCompanyShortName(){
      try {
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload)
        console.log("result =>", result);
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
            'value': CompanyShortList[i].clientid,
            'text': CompanyShortList[i].clientshortname,
          })
        }
      } catch(err){
        console.log(err);
      }
    },
    callParent(data) {
      console.log("data :: ",data);
      this.getConfig()
      this.showCreateLMConfig = false;
      this.parentData = {}
    },
    resetFilter() {
      this.selectedClient = null
      this.selectedHub = null;
      this.onPageChange(1)
    },
    async getConsigneeName() {
      try {
        let input = {}
        if (this.selectedHub && this.selectedHub.value) {
          input.hubid = this.selectedHub.value
        } else if (this.hubid) {
          input.hubid = this.hubid;
        }
        this.Clientlist = [];
        let result = await TripServices.getConsigneeList(input);
        if (result.data.code == 200) {
          let consigneeData = result.data.data;
          for (var i = 0; i < consigneeData.length; i++) {
            this.Clientlist.push({
              'value': consigneeData[i].consigneename,
              'text': consigneeData[i].consigneename,
            })
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/bulkdelivery/bulkdeliveryconfig.component.js